import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductModifier } from "src/models/Products/ProductModifier.models";

interface ProductModifierState {
  modifiers: IProductModifier[];
  modifierToEdit: IProductModifier | null;
}

const initialState: ProductModifierState = {
  modifiers: [],
  modifierToEdit: null
}

const ProductModifierSlice = createSlice({
  name: "Modifier",
  initialState,
  reducers: {
    setProductModifierList: (state, action: PayloadAction<IProductModifier[]>) => {
      state.modifiers = action.payload;
    },
    concatListProductModifier: (
      state: ProductModifierState,
      action: PayloadAction<IProductModifier[]>
    ) => {
      state.modifiers = [...state.modifiers.concat(action.payload)];
    },
    setProductModifierToEdit: (state, action: PayloadAction<IProductModifier | null>) => {
      state.modifierToEdit = action.payload;
    },
    addProductModifier: (state, action: PayloadAction<IProductModifier>) => {
      state.modifiers.push(action.payload);
    },
    updateProductModifier: (state, action: PayloadAction<IProductModifier>) => {
      let itemIndex = state.modifiers.findIndex(
        item => item.productModifierId === action.payload.productModifierId
      );
      if (itemIndex !== -1) state.modifiers[itemIndex] = action.payload;
    },
    deleteProductModifier: (state, action: PayloadAction<string>) => {
      const newArray = state.modifiers.filter(
        item => item.productModifierId !== action.payload
        );
      state.modifiers = newArray;
    },
  },
});

export const {
  setProductModifierList,
  concatListProductModifier,
  setProductModifierToEdit,
  addProductModifier,
  updateProductModifier,
  deleteProductModifier,
} = ProductModifierSlice.actions;

export default ProductModifierSlice.reducer;